import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-[#F7F5F2] flex items-center justify-center p-4">
      <Card className="max-w-md w-full rounded-2xl border-stone-200">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-8 w-8 text-red-500" />
          </div>
          <h1 className="text-2xl font-bold text-stone-800 mb-2 font-['Outfit']">Payment Cancelled</h1>
          <p className="text-stone-600 mb-6">
            Your payment was cancelled. No charges were made.
          </p>
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/subscribe')}
              className="w-full btn-premium"
              data-testid="try-again-button"
            >
              Try Again
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="w-full rounded-full"
              data-testid="go-home-button"
            >
              Go to Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
